import {
    getEventClientDate,
    pageUrlToTriggerLocation,
} from '../utils/analytics';

import {
    TRIGGER_LOCATIONS,
    TRIGGER_OBJECTS,
    TRIGGER_SOURCES,
    TRIGGER_TYPES,
    TOPIC_TAG_ARRS,
    SEMANTIC_EVENTS,
} from './clickstreamConstants';

interface CallZHLParams {
    triggerLocation: string;
    triggerSource: string;
    triggerObject: string;
    zhlPurchaseFunnel?: Record<string, unknown>;
}

interface ClickstreamEvent {
    envelope: {
        event_template_id: string;
        event_template_version_id: string;
        event_type_id: string;
        event_type_version_id: string;
        event_client_start_dtm: string;
    };
    clickstream_trigger: {
        trigger_location_nm: string;
        trigger_type_nm: string;
        trigger_object_nm: string;
        trigger_source_nm: string;
    };
    semantic: {
        semantic_event_nm: string;
        topic_tag_txt: readonly string[];
    };
    zhl_purchase_funnel?: Record<string, unknown>;
}

export const getCallZHL = ({
    triggerLocation,
    triggerSource,
    triggerObject,
    zhlPurchaseFunnel,
}: CallZHLParams): ClickstreamEvent => {
    let topic_tag_txt: readonly string[] = TOPIC_TAG_ARRS.ZHL;
    if (triggerLocation === TRIGGER_LOCATIONS.PURCHASE_FUNNEL) {
        topic_tag_txt = TOPIC_TAG_ARRS.ZHL_PURCHASE;
    } else if (triggerLocation === TRIGGER_LOCATIONS.REFINANCE_FUNNEL) {
        topic_tag_txt = TOPIC_TAG_ARRS.ZHL_REFINANCE;
    }

    return {
        envelope: {
            event_template_id: '127',
            event_template_version_id: '1',
            event_type_id: '2098',
            event_type_version_id: '1',
            event_client_start_dtm: getEventClientDate(),
        },
        clickstream_trigger: {
            trigger_location_nm: triggerLocation,
            trigger_type_nm: TRIGGER_TYPES.INTERACTION,
            trigger_object_nm: triggerObject,
            trigger_source_nm: triggerSource,
        },
        semantic: {
            semantic_event_nm: SEMANTIC_EVENTS.CALL,
            topic_tag_txt,
        },
        ...(zhlPurchaseFunnel && { zhl_purchase_funnel: zhlPurchaseFunnel }),
    };
};

export const currentPageUrlToTriggerLocation = (): string => {
    const { pathname: path, hash: _hash } = window.location;
    return pageUrlToTriggerLocation({ path, _hash }) as string;
};

export const getGeneralCallZHL = (): ClickstreamEvent => {
    const triggerLocation = currentPageUrlToTriggerLocation();
    return getCallZHL({
        triggerLocation,
        triggerSource: TRIGGER_SOURCES.CALL_GENERAL,
        triggerObject: TRIGGER_OBJECTS.FOOTER,
    });
};
